import { render, staticRenderFns } from "./AubeCoinStakingApplication.vue?vue&type=template&id=8b5db812&scoped=true&"
import script from "./AubeCoinStakingApplication.vue?vue&type=script&lang=js&"
export * from "./AubeCoinStakingApplication.vue?vue&type=script&lang=js&"
import style0 from "./AubeCoinStakingApplication.vue?vue&type=style&index=0&id=8b5db812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5db812",
  null
  
)

export default component.exports